import React, { useState } from "react";
import { useEffect } from "react";
import { Row, Modal, ModalHeader, ModalBody, ModalFooter } from "reactstrap";
import { useHistory } from "react-router-dom";
import moment from "moment";
import TeamanicsButton from "../../../../../buttoncomponent/TeamanicsButton";
import { Colxx } from "../../../../../components/common/CustomBootstrap";
import { AiOutlineFileSearch } from "react-icons/ai";
import { ProfileService } from "../../../../../services/ProfileService";
import sortArray from "sort-array";
import { Stringutility } from "../../../../../utilities/stringutility";

const CandidateEducation = () => {
  const history = useHistory();
  const [educationList, setEducationList] = useState([]);
  const [filterededuList, setFilterededuList] = useState([]);
  const [educationId, setEducationId] = useState("");
  const [education, setEducation] = useState("");
  const [modalLong, setModalLong] = useState(false);
  const [educationName, setEducationName] = useState("");
  useEffect(() => {
    getCandidateEducation();
  }, []);

  const [selectedId, setSelectedId] = useState("");
  const [showView, setShowView] = useState(false);

  const [isOpen, setIsOpen] = useState(false);
  const show = (id, index) => {
    setIsOpen(!isOpen);
    if (selectedId == id) {
      setShowView(!showView);
    } else {
      setShowView(true);
    }
    setSelectedId(id);

    // const eduData = [...educationList];
    // eduData[index].isRead = !eduData[index].isRead;
    // setEducationList(eduData);
    const educationData = [...filterededuList];
    educationData[index].isRead = !educationData[index].isRead;
    setFilterededuList(educationData);
  };

  const filterEdu = (eduList) => {
    var x1 = eduList.filter((expItem) => expItem.endDate === 0);
    var p2 = sortArray(x1, { by: "startDate", order: "desc" });
    var y1 = eduList.filter(
      (expItem) => expItem.endDate !== 0 && expItem.startDate !== 0
    );
    var p3 = sortArray(y1, { by: "endDate", order: "desc" });
    var z1 = eduList.filter((expItem) => expItem.startDate === 0);
    setFilterededuList([...z1, ...p2, ...p3]);
  };
  function getDateDifference(startDate, endDate) {
    var sDate = moment(startDate);
    if (endDate == 0 || Stringutility.isNullOrEmpty(endDate)) {
      endDate = new Date();
    }

    var eDate = moment(endDate);

    var years = eDate.diff(sDate, "years");
    var months = eDate.diff(sDate, "months") % 12;
    var days = eDate.diff(sDate, "days");

    var duration = "";
    if (years == 1) duration = years + " Year ";
    if (years > 1) duration = years + " Years ";

    if (months == 1) duration = duration + months + " Month";
    if (months > 1) duration = duration + months + " Months";
    if (months == 0 && years == 0) duration = " Less than a month";
    return duration;
  }
  const getCandidateEducation = () => {
    ProfileService.getEducationsList().then((response) => {
      try {
        if (response.data !== null) {
          var educationDetails = response.data;
          if (educationDetails.eduList != null) {
            if (response.data.eduList.length > 0) {
              for (let i = 0; i < response.data.eduList.length; i++) {
                response.data.eduList[i].isRead = true;
              }
              setEducationList(response.data.eduList);
              filterEdu(response.data.eduList);
              setFilterededuList(response.data.eduList);
            } else {
              setEducationList([]);
              setFilterededuList([]);
            }
          }
        }
      } catch (err) {
        console.error("getEducationsList" + JSON.stringify(err));
      }
    });
  };
  const onAddEducation = (educationId) => {
    const data = { id: educationId };
    history.push({
      pathname: "/addcandidateeducation",
      state: data,
    });
  };

  const handledeletesoftskill = (deleteId, name) => {
    setEducationId(deleteId);
    setEducation(name);
    setModalLong(true);
    setEducationName(name);
  };
  const onDeleteEducation = () => {
    deleteCandidateEducation();
  };
  const handleCancelButton = () => {
    history.push("/smartresume");
  };
  const deleteCandidateEducation = () => {
    ProfileService.deleteEducation(educationId).then((response) => {
      try {
        if (response.data != null) {
          setModalLong(false);
          getCandidateEducation();
        }
      } catch (err) {
        console.error("deleteEducation" + JSON.stringify(err));
      }
    });
  };

  const approveParsedEducation = (eduId) => {
    ProfileService.approveParsedEducationService(eduId).then((response) => {
      try {
        getCandidateEducation();
      } catch (err) {
        console.error("approveParsedEducationService" + JSON.stringify(err));
      }
    });
  };

  const getAddress = (addressObj) => {
    const address = [];
    if (addressObj != null) {
      if (addressObj.city != null) {
        address.push(addressObj.city + ", ");
      }

      if (addressObj.state != null) {
        address.push(addressObj.state);
      }
    }

    return address;
  };
  return (
    <div className="myProfileColumn 
    min-md:col-span-full min-lg:col-span-3 min-2xl:col-span-2 max-md:col-span-full
    min-lg:order-1 max-lg:order-2 t-profile-mb
">



<div className="myProfile-container relative  min-sm:grid-cols-3 min-sm:auto-rows-max min-sm:auto-cols-max gap-0 max-sm:mb-16 max-sm:pb-12 bg-primary-white min-sm:rounded-xl shadow-lg t-profile-padding ">
        <div className="col-sm-12">
          <div className="barmenu_content">
            <div className="addexperience right">
              <div className="skill-header">
                <div>
                  <div className="profile-card-title">
                    <div className="row">
                        <div className="col">
                          <h2 className="t-h2-font-sm">
                            <strong>Education</strong>
                          </h2>
                        </div>{" "}
                    </div>

                    <div className="horizontal_line"></div>
                    <div className="col mt-3">
                      <div className="row">
                        <div>
                          <TeamanicsButton onClick={() => onAddEducation("")}>
                            Add Education
                          </TeamanicsButton>
                        </div>
                        <div className="col t-button-flex-end">
                          <div className="row">
                            <div className="">
                              <AiOutlineFileSearch
                                color="red"
                                size="20"
                                title="Please review smart resume"
                              />
                            </div>
                            <div className="">
                              Info scanned from your resume, please review
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            {filterededuList.length > 0 ? (
              <Row className="mb-5 mt-3">
                <Colxx xxs="12">
                  {filterededuList.length > 0 ? (
                    filterededuList.map((education, index) => (
                      <div
                        key={index}
                        className="min-sm:bg-white min-sm:shadow-lg min-sm:rounded-2xl min-sm:border min-sm:px-6 min-sm:py-8 w-full mb-5 t-padding-bottom-[12px] t-padding-top-[12px]"
                        style={{
                          borderRight:
                            education.fromParse === true ? "4px solid red" : "",
                        }}
                      >
                        <div>
                          <div className="row ">
                            <div className="ml-3 mt-1">
                              {education.fromParse === true ? (
                                <div
                                  style={{
                                    color:
                                      education.fromParse === true ? "red" : "",
                                  }}
                                >
                                  <AiOutlineFileSearch
                                    className="mr-2 t-hand-cursor-pointer"
                                    size="20"
                                    title="Info scanned from your resume, please review"
                                  />
                                </div>
                              ) : (
                                <></>
                              )}
                            </div>
                            <div className="font-semibold text-lg text-primary-blue">
                              {education.educationType}
                            </div>
                          </div>
                          <div>{education.major}</div>
                          <div>{getAddress(education.address)}</div>
                          <p>
                            {/* {displayDate(
                                  education.startDate,
                                  education.endDate
                                )}    */}
                            {education.endDate == 0 ? (
                              <></>
                            ) : (
                              <>
                                {education.startDate == 0 &&
                                education.endDate !== 0 ? (
                                  <>
                                    {moment(education.endDate).format(
                                      "MM/YYYY"
                                    )}
                                  </>
                                ) : (
                                  <>
                                    {moment(education.startDate).format(
                                      "MM/YYYY"
                                    ) +
                                      " - " +
                                      moment(education.endDate).format(
                                        "MM/YYYY"
                                      )}
                                  </>
                                )}
                              </>
                            )}{" "}
                            <span className="font-normal text-sm">
                              {" "}
                              {education.startDate == 0 ||
                              education.endDate == 0 ? (
                                <></>
                              ) : (
                                <>
                                  (
                                  {getDateDifference(
                                    education.startDate,
                                    education.endDate
                                  )}
                                  )
                                </>
                              )}
                            </span>
                            {/* {" "}     
                                <span className="font-normal text-sm">
                              {' '}
                              { education.startDate==0||education.endDate==0?(<></>):(<>(
                              {getDateDifference(
                                education.startDate,
                                education.endDate,
                              )}
                              )</>)}
                              
                            </span>                     */}
                          </p>

                          {!Stringutility.isNullOrEmpty(
                            education.description
                          ) && (
                            <a>
                              <span
                                className="t-hand-cursor-pointer text-primary-blue"
                                onClick={() => show(education.id, index)}
                              >
                                {education.isRead ? (
                                  <>
                                    See Less{" "}
                                    <i className="simple-icon-arrow-down t-icon-size-[8px]" />
                                    <div className="t-description-text-color t-parsed-text">
                                      {education.description}
                                    </div>
                                  </>
                                ) : (
                                  <>
                                    See More{" "}
                                    <i className="simple-icon-arrow-up t-icon-size-[8px]" />
                                  </>
                                )}
                              </span>
                            </a>
                          )}

                          <div>
                            <>
                              <div className="row">
                                <div className="">
                                  <span
                                    className="t-hand-cursor-pointer"
                                    onClick={() => {
                                      onAddEducation(education.id);
                                    }}
                                  >
                                    <TeamanicsButton className="mt-3 ml-3">Edit</TeamanicsButton>
                                  </span>
                                </div>
                                <div className="">
                                  <span to="">
                                    <TeamanicsButton
                                      className="ml-2 mt-3"
                                      onClick={() =>
                                        handledeletesoftskill(
                                          education.id,
                                          education.major
                                        )
                                      }
                                    >
                                      Delete
                                    </TeamanicsButton>
                                  </span>
                                </div>
                                {education.fromParse === true ? (
                                  <span title="Accept Education Entry">
                                    <TeamanicsButton
                                      className="ml-2 mt-3"
                                      onClick={() =>
                                        approveParsedEducation(education.id)
                                      }
                                    >
                                      Accept
                                    </TeamanicsButton>
                                  </span>
                                ) : (
                                  <></>
                                )}
                              </div>
                            </>
                          </div>
                        </div>
                      </div>
                    ))
                  ) : (
                    <></>
                  )}
                </Colxx>
                <TeamanicsButton className="mt-3 ml-3" onClick={handleCancelButton}>
                  Cancel
                </TeamanicsButton>
                <TeamanicsButton className="mt-3 ml-3" onClick={handleCancelButton}>
                  Save
                </TeamanicsButton>
              </Row>
            ) : (
              <>
                <div className="loginname mt-1">
                  <label>No data found</label>
                </div>
              </>
            )}
          </div>
        </div>
      </div>

      <Modal isOpen={modalLong} toggle={() => setModalLong(!modalLong)}>
        <ModalHeader>
          {" "}
          <strong>Delete education</strong>
        </ModalHeader>
        <ModalBody>
          <label>Do you want to delete {educationName} Education?</label>
        </ModalBody>
        <ModalFooter className=" t-modal-footer-btn">
          <TeamanicsButton onClick={() => setModalLong(false)}>Close</TeamanicsButton>{" "}
          <TeamanicsButton
            onClick={() => {
              onDeleteEducation();
            }}
          >
            Delete
          </TeamanicsButton>{" "}
        </ModalFooter>
      </Modal>
    </div>
  );
};

export default CandidateEducation;
